import axios from "axios";
import cookie from 'js-cookie';
import StateHandler from './StateHandler';
import StoreEmitter from "./StoreEmitter";

export default {
  name: 'BaseReq',

  sendLoadText(params) {
    StateHandler.store.commit('setLoadingText', params);
  },

  ejectInter(inst) {
    axios.interceptors.response.eject(inst);
  },

  // 初始化拦截器
  initInter() {
    axios.interceptors.request.use((config) => {
      const copyConfig = config;
      if (copyConfig.url.lastIndexOf('app/rest/data.json/query') !== -1) {
        if (copyConfig.url.lastIndexOf('?') === -1) {
          copyConfig.url += `?_g=${copyConfig.data.groupby}&_m=${copyConfig.data.metrics.join(',')}`;
        }
      } else if (copyConfig.url.lastIndexOf('indicator/query') !== -1) {
        if (copyConfig.url.lastIndexOf('?') === -1) {
          copyConfig.url += `?_g=${copyConfig.data.groupBy}&_m=${copyConfig.data.metrics}`;
        }
      } else if (copyConfig.url.lastIndexOf('app/metaDataService') !== -1) {
        if (copyConfig.method === 'post' || copyConfig.method === 'put' || copyConfig.method === 'delete') {
          copyConfig.headers = {
            'token': 'mytoken',
          };
        }
      }
      return config;
    }, (error) => {
      return Promise.reject(error);
    });

    return axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response) {
        let content = '';
        if (error.response.status === 400 || error.response.status === 503) {
          content = error.response.data;
        }
        if (error.response.data && error.response.data.exception) {
          content = error.response.data.exception;
          if (content === 'org.springframework.dao.DataIntegrityViolationException') {
            const contArray = error.response.data.message.split(';');
            content = contArray[2];
          }
        } else if (error.response.data && error.response.data.data) {
          if (error.response.data.data.indexOf('Storage metaData verify fail :') !== -1) {
            const msgArray = error.response.data.data.split('Storage metaData verify fail :');
            content = '"' + msgArray[1];
          }
        }
        StoreEmitter.$emit('msg-alert-error', { title: '服务器错误 ' + error.response.status, desc: content });
      }
      return Promise.reject(error);
    });
  },

  // 检测灰度逻辑
  checkPermission() {
    const token = `/${cookie.get('_app_token_')}`;
    if (!cookie.get('_app_token_')) {
      return Promise.resolve(false);
    }
    this.sendLoadText('checkPermission');
    return axios.get('/app/rest/developer.json/getSession' + token).then(async (resObj1) => {
      if (resObj1.status === 200) {
        if (resObj1.request.responseURL === 'https://www.talkingdata.com/products.jsp') {
          return;
        } else {
          const retObj = resObj1.data;

          if (!retObj.result) {
            return;
          }

          StateHandler.store.commit('setDeveloperObj', retObj.result);

          await this.checkEnv(retObj.result.email);
          await this.getProductList();
          return true;
        }
      }
    }, () => {
      return Promise.resolve(false);
    });
  },

  checkEnv(uid) {
    this.sendLoadText('checkEnv');
    return axios.get(`/app/rest/env_router/get?email=${uid}`).then((resObj2) => {
      if (resObj2.status == 200) {
        const res = resObj2.data;

        StateHandler.isPageGray = res.isPageGray;
        StateHandler.isPre = res.isPre;

        if (res.isPageGray) {
          cookie.set('_canary_app_api_', 'true');
        } else {
          cookie.remove('_canary_app_api_');
        }

        // 判断前端独立灰度cookie
        const hasFrontGray = cookie.get('grayFrontStatus') !== undefined;
        if (res.isPageGray && !hasFrontGray) {
          cookie.set('grayDeveloperId', 'true');
          cookie.set('grayFrontStatus', 'true');
          location.reload(true);
        } else if (!res.isPageGray && hasFrontGray) {
          cookie.remove('grayDeveloperId');
          cookie.remove('grayFrontStatus');
          location.reload(true);
        }
      }
    });
  },

  getProductList() {
    const AnalyticsPublic = StateHandler.store.state.transFilterObj;

    const token = `/${cookie.get('_app_token_')}`;
    this.sendLoadText('getProductList');
    return axios.get('/app/rest/product.json/get' + token).then(retObj => {
      StateHandler.store.commit('setProductList', retObj.data.result);

      if (retObj.data.result && retObj.data.result.length > 0) {
        let prodObj = null;
        if (!AnalyticsPublic.productid) {
          prodObj = retObj.data.result[0];
        } else {
          prodObj = retObj.data.result.find(item => {
            return item.productid == AnalyticsPublic.productid;
          });
          if (prodObj == null) {
            prodObj = retObj.data.result[0];
          }
        }
        StateHandler.store.commit('setProductObj', prodObj);

        const pObj = prodObj;
        const tmpObj = {
          productid: '' + pObj.productid,
          productname: pObj.productname,
          registertime: pObj.registertime,
          authorized: pObj.authorized,
          watchshow: pObj.watchshow,
          platformFull: pObj.platform,
          platform: pObj.platform,
        };

        StateHandler.savePublic(tmpObj);
      }
    });
  },
};